<template>
  <div class="quiz-test-buttons">
    <div class="reload">
      <button v-if="disabledBtn" class="btn" type="button" :style="{ backgroundColor: color1 }" @click="reloadLesson">
        <img src="@/assets/img/reload.png" alt />
      </button>
      <label v-if="disabledBtn">{{ $t('testboard.oneMoreTime') }}</label>
    </div>
    <div class="next">
      <img v-if="disabledBtn" src="@/assets/icons/lock_step1_open.png" alt class="closed" />
      <img v-if="disabledBtnNext" src="@/assets/tests/elements-1-4/lock-open.gif" alt />
      <button v-if="disabledBtnNext" class="btn" type="button" :style="{ backgroundColor: color2 }" @click="nextPage">
        {{ $t('testboard.nextLesson') }}
      </button>
      <!-- <button v-if="$store.state.currentLesson.next.path && disabledBtnNext" class="btn" type="button" @click="nextPage" :style="{backgroundColor: color2}">{{ $t('testboard.nextLesson') }}</button> -->
      <!-- <label class="next-lesson" v-if="disabledBtn">{{ $t('testboard.nextLesson') }}</label> -->
      <!-- <button v-if="!$store.state.currentLesson.next.path && disabledBtnNext" class="btn" type="button" @click="nextPage" :style="{backgroundColor: color2}">{{ $t('testboard.clusterFinished') }}</button> -->
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  props: ['disabledBtn', 'disabledBtnNext', 'colors'],
  data() {
    return {
      color1: '',
      color2: '',
    };
  },
  computed: {
    ...mapGetters({
      authenticatedUser: 'auth/userAuthenticated',
      clusterActivityIdCurrent: 'clusterActivity/activityIdCurrent',
      nextLesson: 'lesson/nextLesson',
      currentLesson: 'lesson/currentLesson',
      lessons: 'lesson/list',
    }),
  },
  created() {
    // TODO kionoi
    if (this.colors) {
      this.color1 = this.colors[0];
      this.color2 = this.colors[1];
    } else {
      this.color1 = '#429999';
      this.color2 = '#429999';
    }
  },
  methods: {
    ...mapActions({
      createLessonActivity: 'lessonActivity/FETCH_CREATE',
    }),
    onCreateLessonActivity() {
      this.createLessonActivity({
        data: {
          lesson_id: this.nextLesson.id,
          cluster_activity_id: this.clusterActivityIdCurrent,
        },
      });
    },
    reloadLesson() {
      this.$router.push({
        name: 'lesson',
        params: {
          lesson_id: this.$route.params.lesson_id,
          cluster_id: this.$route.params.cluster_id,
        },
      });
    },
    async nextPage() {
      this.$activity.$emit('save-lesson-activity');

      if (this.nextLesson) {
        await this.$store.commit('lesson/SET_CURRENT_LESSON', this.nextLesson);
      }

      return this.$router.push({ name: 'lesson', params: { lesson_id: this.currentLesson.id } });
    },
  },
};
</script>
<style lang="scss" scoped>
.quiz-test-buttons {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  line-height: 1;
}
.reload {
  padding: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  button {
    display: flex;
    padding: 5px;
    img {
      width: 35px;
      height: 35px;
    }
  }
  label {
    margin-left: 10px;
    font-size: 18px;
    margin-bottom: 0;
  }
}
.next {
  padding: 15px;
  display: flex;
  justify-content: center;
  align-items: center;
  img {
    width: 30px;
    height: auto;
    margin-right: 10px;
    &.closed {
      width: 25px;
    }
  }
  button {
    font-size: 20px;
  }
}
.btn {
  box-shadow: 5px 5px 10px rgba($color: #000000, $alpha: 0.5);
  user-select: none;
  border: 1px solid transparent;
  border-radius: 0.25rem;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  cursor: pointer;
  color: #fff;
  &.disabled {
    background-color: rgba($color: #607d8b, $alpha: 0.8);
    border-color: rgba($color: #607d8b, $alpha: 0.8);
  }
}

.btn:hover {
  background-color: rgba($color: #607d8b, $alpha: 0.8);
}
.btn:disabled {
  cursor: not-allowed;
}
.next-lesson {
  margin-bottom: 0;
}
</style>
